module.exports = __webpack_public_path__ + "img/c-clients-3.jpg";